import { Carousel, CarouselSlides } from '@jouzen/ecom-components/v4/Carousel';
import { useEffect, useRef, useState } from 'react';

import HeroCarouselNav from './HeroCarouselNav';
import HeroCarouselSlide, {
  type HeroCarouselSlideProps,
} from './HeroCarouselSlide';

export interface HeroCarouselProps {
  readonly slides: HeroCarouselSlideProps[];
  readonly resetKey?: string;
}

const HeroCarousel = ({ slides, resetKey }: HeroCarouselProps) => {
  const [resetSlides, setResetSlides] = useState<boolean>(false);
  const previousResetKey = useRef(resetKey);

  // Reset slides when finish changes
  useEffect(() => {
    if (previousResetKey.current !== resetKey) {
      setResetSlides(true);
      const timeout = setTimeout(() => setResetSlides(false), 0);
      return () => clearTimeout(timeout);
    }
    previousResetKey.current = resetKey;
    return () => undefined;
  }, [resetKey]);

  return (
    <Carousel
      autoplay
      className="w-full max-lg:h-[70svh] lg:aspect-[6/5] lg:max-h-[80svh]"
      data-cy="hero-carousel"
      infinite
      resetSlides={resetSlides}
    >
      <CarouselSlides className="lg:rounded-r-3xl">
        {slides.map((slide, i) => (
          <HeroCarouselSlide
            {...slide}
            index={i}
            key={`hero-carousel-slide-${i}`}
          />
        ))}
      </CarouselSlides>
      <HeroCarouselNav />
    </Carousel>
  );
};

export default HeroCarousel;
